import styles from './historie-gaza-barn.module.css'
import './media/ball01.png'
import './media/ball02.png'
import './media/bamse01.png'
import './media/bamse02.png'
import './media/sjiraff01.png'
import './media/sjiraff02.png'
import './media/bil01.png'
import './media/bil02.png'
import './media/motorsykkel02.png'
import './media/rubiks-kube01.png'
import './media/rubiks-kube02.png'
import './media/larve01.png'
import './media/klosser.png'
import './media/klosserAB.png'
import './media/klosserABC.png'
import './media/rassler.png'
import './media/rassler2.png'
import './media/regnbue.png'
import './media/taarn.png'
import './media/yoyo.png'
import './media/yoyo2.png'
import './media/jafra-dukke01.png'

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export default function hydrate(el, props) {
  const images = el.querySelectorAll('img')

  const observer = new IntersectionObserver(
    (entries) => {
      for (const entry of entries) {
        if (entry.isIntersecting) {
          entry.target.classList.toggle(styles.visible, true)
          observer.unobserve(entry.target)
        }
      }
    },
    {
      threshold: 0,
      rootMargin: '-10% 0px -10% 0px',
    },
  )

  for (const image of images) {
    observer.observe(image)
  }

  return () => {
    observer.disconnect()
  }
}
